import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

//Polyfill for Chart.js, on ios
(async () => {
  if ('ResizeObserver' in window === false) {
    // Loads polyfill asynchronously, only if required.
    //const module = await import('@juggle/resize-observer');
    //window.ResizeObserver = module.ResizeObserver;
  }
})();

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.log(err));
console.log('=====> PWA COMPILED AT 12/29/2023, 12:35:16 AM <=====');
